import { Injectable } from '@angular/core';
import {AbstractApiService} from "@shared/services/abstract-api.service";
import {environment} from "../../../../environments/environment";
import { HttpHeaders } from '@angular/common/http';
import { RedirectHandlerResult } from './models/redirect-handler-result.model';
import { map } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class RedirectHandlerService extends AbstractApiService {

  redirectHandlerResult :RedirectHandlerResult;

  constructor() {
    super();
  }

  getRedirectUrl(code: string) : Promise<string> {

    const headers = new HttpHeaders({ 'token': environment.tokenAuthBridge });
    return firstValueFrom(
      this._httpClient.get<RedirectHandlerResult>(environment.apiTMAuthBridge + `/ShortUrl?link=${code}`, { headers: headers })
        .pipe(
          map(result => result?.targetUrl || '')
        )
    );

  }
}
